export const TOAST_TYPE = {
  ERROR: 'error',
  SUCCESS: 'success',
}
